import type { MenuOptions } from './types/general';

import DndLogo from './img/dnd_logo.png';
import FbLogo from './img/fb_logo.png';
import FhbfFachberatungsstelleLogo from './img/fhbf_fachberatungsstelle_logo.png';
import FhbfInterventionsstelleLogo from './img/fhbf_interventionsstelle_logo.png';
import FhfLogo from './img/fhf_logo.png';

const reactAppVersion = process.env.REACT_APP_VERSION;

const dndMenu: MenuOptions = {
  title: 'dick und dünn Dokutool',
  logo: DndLogo,
  logoLink: '/clients',
  entries: [
    { label: 'Telefonische Beratung', link: '/clients' },
    { label: 'Statistik', link: '/statistics' },
  ],
  hasLogout: false,
};

const fbMenu: MenuOptions = {
  title: 'frauenBeratung Dokutool',
  logo: FbLogo,
  logoLink: '/clients',
  entries: [
    { label: 'Klient*innen', link: '/clients' },
    { label: 'Sonstige Dokumentation', link: '/documentation' },
    { label: 'Statistik', link: '/statistics' },
    { label: 'Einstellungen', link: '/settings' },
  ],
  hasLogout: true,
};

const fhbfMenu = (location: string): MenuOptions => {
  const logo = location.includes('interventionsstelle') ? FhbfInterventionsstelleLogo : FhbfFachberatungsstelleLogo;

  return {
    title: 'Frauenhaus Fürth Dokutool',
    logo,
    logoLink: '/startpage',
    entries: [
      {
        label: 'Fachberatungsstelle',
        link: '/fachberatungsstelle/clients',
        subEntries: [
          { label: 'Klient*innen', link: '/fachberatungsstelle/clients' },
          { label: 'Sonstige Dokumentation', link: '/fachberatungsstelle/documentation' },
          { label: 'Statistik', link: '/fachberatungsstelle/statistics' },
          { label: 'Einstellungen', link: '/fachberatungsstelle/settings' },
        ],
      },
      {
        label: 'Interventionsstelle',
        link: '/interventionsstelle/clients',
        subEntries: [
          { label: 'Klient*innen', link: '/interventionsstelle/clients' },
          { label: 'Sonstige Dokumentation', link: '/interventionsstelle/documentation' },
          { label: 'Statistik', link: '/interventionsstelle/statistics' },
          { label: 'Regierung Statistik', link: '/interventionsstelle/governmentStatistics' },
        ],
      },
    ],
    hasLogout: true,
  };
};

const fhfMenu: MenuOptions = {
  title: 'Frauenhaus Fürth Dokutool',
  logo: FhfLogo,
  logoLink: '/clients',
  entries: [
    { label: 'Übergabe', link: '/transfer' },
    { label: 'Warteliste', link: '/waitingList' },
    { label: 'Frauen', link: '/clients' },
    { label: 'Kinder', link: '/children' },
    { label: 'Second Stage', link: '/secondStage' },
    { label: 'Einstellungen', link: '/settings' },
  ],
  hasLogout: true,
};

const getMenuOptions = (location: string): MenuOptions => {
  if (reactAppVersion === 'dnd') {
    return dndMenu;
  }
  if (reactAppVersion === 'fb') {
    return fbMenu;
  }
  if (reactAppVersion === 'fhbf') {
    return fhbfMenu(location);
  }
  if (reactAppVersion === 'fhf') {
    return fhfMenu;
  }
  return {
    title: '',
    logo: '',
    logoLink: '',
    entries: [],
    hasLogout: false,
  };
};

export default getMenuOptions;
